import { v4 } from 'uuid';
import { irisClient } from './iris';
export var sendScreenshotData = function (modalSessionId, uniqueUserId, encodedScreenshot) {
    var messageId = v4();
    var timestamp = (Date.now() / 1000).toFixed(6);
    var screenshotUrl = "".concat(timestamp, ".jpeg");
    var properties = {
        screenshotUrl: screenshotUrl,
        encodedScreenshot: encodedScreenshot,
        modalSessionId: modalSessionId,
    };
    var payload = {
        anonymousId: modalSessionId,
        event: 'edge_native_screenshot',
        userId: uniqueUserId,
        properties: properties,
        messageId: messageId,
    };
    irisClient.trackArtifacts(payload);
};
export default sendScreenshotData;
